import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'user-pub-informations-skeleton',
  templateUrl: './informations-skeleton.component.html',
  styleUrls: ['./informations-skeleton.component.scss']
})
export class UserProfileInformationsSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
